export default {"src":"/_next/static/media/orange_star.b5c25208.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};